import styled from "styled-components";
import ArrowLeft from "assets/iconsOld/arrowLeft.svg";
import ArrowRight from "assets/iconsOld/arrowRight.svg";

const NavigationBtn = styled.button`
  width: 35px;
  height: 100%;
  top: 0;
  bottom: 0;
  margin-top: unset;
  left: unset;
  border: none;
  background-color: transparent;
  
  background-image: none;
  background-size: 10px;
  background-repeat: no-repeat;
  background-position: center;

  transition: 200ms;
  opacity: .5;
  
  ::after {
    content: none;
  }

  :hover {
    opacity: 1;
  }
`

export const ButtonPrev = styled(NavigationBtn)`
  right: 100%;
  background-image: url(${ArrowLeft});
`

export const ButtonNext = styled(NavigationBtn)`
  left: 100%;
  background-image: url(${ArrowRight});
`